import { NAMED_CACHE_NAME } from "@/shared/utils/sw/sw.constants";
import { selectorNamedCacheKeysAvailable } from "@/shared/store/sw/selectorNamedCacheKeysAvailable";

export const selectorDownloadedBooksIds = (state) => {
  return selectorNamedCacheKeysAvailable(state)[NAMED_CACHE_NAME.BOOK_DATA];
};